import type AjaxRequestBroker from "../AjaxRequestBroker";
import type {ApiOpts} from "@esWebAPI/es/model/Models";

const es = global.es;

export default class MCPModule {

    private rqBroker: AjaxRequestBroker;
    private resourceName: string;

    constructor(rqBroker: AjaxRequestBroker, resourceName: string) {
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
    }

    public init(opts?: ApiOpts) {
        return this.rqBroker.doPost({
            url: es.api.getURL(this.resourceName) + '/init_session',
            opts: opts
        });
    }

    public callTool(toolName: string, args: object, opts?: ApiOpts) {
        return this.rqBroker.doPost({
            url: es.api.getURL(this.resourceName) + '/tool/' + toolName,
            data: args,
            opts: opts
        });
    }
}
